// @ts-expect-error png import
import CompaignBriefHero from 'bender-url!./images/CampaignBriefHero.png';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import CustomerAgentIcon from './images/icons/CustomerAgentIcon';
import LookalikeListsIcon from './images/icons/LookalikeListsIcon';
import MarketingStudioIcon from './images/icons/MarketingStudioIcon';
import SMSWhatsAppIcon from './images/icons/SMSWhatsAppIcon';
import SolutionCardLayoutUI from './SolutionCardLayoutUI';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompaignBriefCard = () => {
  return /*#__PURE__*/_jsx(SolutionCardLayoutUI, {
    reverse: true,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.solutionCards.campaignBrief.title"
    }),
    subheading: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.hsoc.solutionCards.campaignBrief.subheading"
        })
      }), ' ', /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Link, {
          underline: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.hsoc.solutionCards.learnMore"
          })
        })
      })]
    }),
    features: [{
      icon: /*#__PURE__*/_jsx(SMSWhatsAppIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.smsWhatsApp.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.smsWhatsApp.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(MarketingStudioIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.marketingStudio.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.marketingStudio.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(CustomerAgentIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.customerAgent.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.customerAgent.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(LookalikeListsIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.lookalikeLists.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.lookalikeLists.description"
      })
    }],
    image: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      justifyContent: "center",
      alignItems: "center",
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(Image, {
        src: CompaignBriefHero,
        zIndex: 1
      })
    }),
    footer: /*#__PURE__*/_jsx(Link, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.seePricing"
      })
    })
  });
};
export default CompaignBriefCard;